var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchPrice"},_vm._l((_vm.washServicePriceList),function(item,index){return (item.servicePrice)?_c('div',{key:index,staticClass:"price-item",on:{"click":function($event){return _vm.onPrice(item)}}},[_vm._v("\n        "+_vm._s(item.service.serviceName)+" ("+_vm._s(item.servicePrice)+"元)\n    ")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }